var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRun = function SvgRun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 27 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#282D2D",
    strokeWidth: 3,
    d: "M16.278 31.386c1.906-.684 3.498-1.561 7.199-1.374m1.462.12q.507.055 1.061.135M3.778 14.536c1.91-1.91 6.11-3.633 9.723-2.228 5.729 2.228 3.82 5.992 11.111 6.483m-10.698-6.794c-1.913 2.927-4.765 6.225-.53 8.007 4.126 1.735 6.184 3.914 6.54 10.497M12.11 18.793c-.529 1.336-2.01 4.046-3.703 4.192S2.764 20.615 1 19.339m1.39 10.648c5.035.918 7.537 2.827 12.667 1.63m-9.89-5.826c.727.555 2.834 2.374 4.187.182M19.058 5.5c0 1.932-1.555 3.498-3.472 3.498s-3.473-1.566-3.473-3.498S13.668 2 15.586 2s3.472 1.566 3.472 3.499Z"
  })));
};
export default SvgRun;